
import Cookies from 'js-cookie'

export default {
  paymentTracking: function (route) {
    let data = {}
    // users without a value get 'website'
    data.tb4tnp_mkt_email_id = Cookies.get('tb_ref') || 'website'
    Cookies.remove('tb_ref')
    if (Cookies.get('tb_test')) data.tbnp_mkt_test_id = Cookies.get('tb_test')
    data.tb4taa_mkt_form_id = route.path
    return data
  },
  removeMarketingCookies: function () {
    Cookies.remove('tb_mkt')
  },
  removeAllCookies: function () {
    Cookies.remove('tb_ref')
    Cookies.remove('tb_test')
    Cookies.remove('tb_mkt')
  },
  marketingParams: function (type) {
    let marketingTags = {}
    let prefix = (type || 'tb') + 'aa_'

    if (Cookies.getJSON('tb_mkt')) {
      Object.assign(marketingTags, Cookies.getJSON('tb_mkt'))
    } else {
      marketingTags.utm_source = 'website'
    }
    marketingTags.utm_content = 'TB4T'

    let prefixedTags = {}
    for (let unTypedKey in marketingTags) {
      if (marketingTags.hasOwnProperty(unTypedKey)) {
        prefixedTags[prefix + unTypedKey] = marketingTags[unTypedKey]
      }
    }

    return prefixedTags
  }
}



// WEBPACK FOOTER //
// ./src/services/marketing.js